import React from 'react'

import {
    GridContainerEstudoPadraoMd,
} from '../estudo-form/EstudoComp'

import EstudoFormGarantiasReceitaMensalDetalhada from '../estudo-form/EstudoFormGarantiasReceitaMensalDetalhada'

import EstudoFormDespesasDespesaMensalDetalhada from '../estudo-form/EstudoFormDespesasDespesaMensalDetalhada'

import BalancoReceitaXDespesaAnualChart from '../estudo-chart/BalancoReceitaXDespesaAnualChart'


const GestaoPatrimonialFormFluxoCaixa = ( { variaveisGlobais, values, estudo, vars } ) => {

    return (
        <>
            <GridContainerEstudoPadraoMd
                component={
                    <EstudoFormGarantiasReceitaMensalDetalhada
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        estudo={estudo}
                        vars={vars}
                        popup={false}
                        popupGrafico={true}
                    />
                }
            />

            <GridContainerEstudoPadraoMd
                component={
                    <EstudoFormDespesasDespesaMensalDetalhada
                        values={values}
                        estudo={estudo}
                        vars={vars}
                        popup={false}
                        popupGrafico={true}
                    />
                }
            />
            
            <BalancoReceitaXDespesaAnualChart
                variaveisGlobais={variaveisGlobais}
                values={values}
                estudo={estudo}
                vars={vars}
            />
        </>
    )
}

export default GestaoPatrimonialFormFluxoCaixa